import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "grid",
  id: "databaseGrid"
}

import Card from "@/components/global/Card.vue";
import WideCard from "@/components/global/WideCard.vue";
import * as DatabaseManager from "../../firebase/DatabaseManager";
import * as Lang from "@/i18n/lang";

import { defineComponent } from "vue";
import Database from "@/model/Database";
import { getDatabaseState } from "@/pinia/databases/DatabaseState";
import { getState } from "@/pinia/NavigationState";
import { getDistributorManager } from "@/firebase/DistributorManager";
const __default__ = defineComponent({
  props: ["databases"],

  methods: {
    getDistributorName(database: Database) {
      if (database.distributor == null) {
        return "Aucun distributeur";
      }
      var distributor = getDistributorManager().getDistributorFromCache(
        database.distributor
      );

      if (distributor == null) {
        return "! Distributeur inconnu ! ";
      }
      return distributor.name;
    },
    onDatabaseClick(database: Database) {
      getDatabaseState().set(database);
      getState().navigate("database");
    },
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DatabaseList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.databases, (database) => {
      return (_openBlock(), _createBlock(WideCard, {
        key: database.id,
        click: () => _ctx.onDatabaseClick(database),
        icon: 
          database.illustration_url == null
            ? '/ico/database.svg'
            : database.illustration_url.get()
        ,
        title: database.name
      }, {
        subtitle: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.getDistributorName(database)), 1)
        ]),
        _: 2
      }, 1032, ["click", "icon", "title"]))
    }), 128))
  ]))
}
}

})